export const breakpoints = {
    lg: 1291,
    md: 768,
    sm: 0,
};

export const getIsTouch = () => 'ontouchstart' in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints;

export const getIsDesktop = () => !getIsTouch() && window.matchMedia(`only screen and (min-width: ${breakpoints.md + 1}px)`).matches;

export const getIsTablet = () => getIsTouch() && window.matchMedia(`only screen and (max-width: ${breakpoints.md}px) and (min-width: ${breakpoints.sm + 1}px)`).matches;

export const getIsPhone = () => getIsTouch() && window.matchMedia(`only screen and (max-width: ${breakpoints.sm}px)`).matches;

export const getIsLG = () => window.matchMedia(`only screen and (min-width: ${breakpoints.md + 1}px)`).matches;

export const getIsMD = () => window.matchMedia(`only screen and (max-width: ${breakpoints.md}px) and (min-width: ${breakpoints.sm + 1}px)`).matches;

export const getIsSM = () => window.matchMedia(`only screen and (max-width: ${breakpoints.sm}px)`).matches;
